<template>
  <div class="basic-information">
    <div class="header">
      <div class="title">
        <i class="ri-information-fill icon"></i>基本信息
      </div>
    </div>
    <el-form :model="agentBasicInfoVModel" :rules="rules" ref="form" label-position="top" label-width="auto"
      class="form-container">
      <el-form-item label="智能体名称" prop="projectName">
        <el-input v-model="agentBasicInfoVModel.projectName" placeholder="请输入智能体名称" maxlength="80" show-word-limit />
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input v-model="agentBasicInfoVModel.description"
          placeholder="请描述您的智能体,比如:一个温暖而聪明的人工智能小伙伴，喜欢探索新知，乐于与用户分享每一个有趣的发现。" maxlength="200" show-word-limit
          type="textarea" rows="5" resize="none" />
      </el-form-item>
      <el-form-item label="角色设定" prop="prePrompt">
        <template #label>
          <div class="form-label">
            <span>
              <el-tooltip effect="light" content="这里可以写给AI的一些建议或者规则，比如告诉AI怎么回答问题。" placement="top-start">
                <el-button text style="padding: 0;">
                  角色设定
                  <el-icon style="margin-left: 3px;">
                    <QuestionFilled />
                  </el-icon>
                </el-button>
              </el-tooltip>
            </span>
            <div class="form-label-right">
              <el-tooltip effect="light" content="点击这个按钮，AI会根据您选择的行业职业帮助您撰写内容。" placement="top-start">
                <el-button type="primary" link :loading="btnLoading" class="ai-helper-button" @click="handleAiWrite">
                  <i class="ri-bard-fill bard-star" style="margin-right: 5px" />AI帮写
                </el-button>
              </el-tooltip>
              <el-tooltip effect="light" content="点击这个图标，您可以设置行业和职业信息，让AI更好地了解您的需求。" placement="top-start">
                <el-button @click="openTrackSettingDialog" class="ai-helper-button">
                  <i class=" ri-equalizer-line  bard-star" @click="openTrackSettingDialog"></i>所属行业/职业
                </el-button>
              </el-tooltip>
            </div>
          </div>
        </template>
        <el-input v-model="agentBasicInfoVModel.prePrompt" placeholder="# 设定
你是一位充满活力且极具洞察力的产品销售顾问，专注于通过深入了解客户需求来提供最合适的解决方案，使购买过程既愉快又高效。

## 技能
### 技能1: 客户需求分析
- 通过有效的沟通技巧，快速准确地了解客户的实际需求和期望。
- 分析客户背景信息，为推荐最适合的产品或服务打下坚实基础。
### 技能2: 产品知识与演示
- 深入掌握所售产品的特点、优势及应用场景，能够清晰、有条理地向客户展示。
- 根据客户需求定制化演示，突出产品如何解决客户的具体问题。
### 技能3: 解决方案定制
- 结合客户需求和产品特性，提出创新且实用的解决方案。
- 协助客户评估不同选项，确保他们做出最满意的选择。
### 技能4: 客户关系管理
- 建立长期稳定的客户关系，通过定期跟进和关怀提升客户满意度。
- 面对客户疑问或投诉时，保持耐心和专业，迅速响应并寻求满意的解决方案。

## 限制条件
- 专注于提高客户体验和满意度，确保每一次交流都是积极正面的。
- 所有的产品介绍和解决方案建议都基于真实可靠的信息，避免夸大其词。
- 在追求销售业绩的同时，始终将客户的利益放在首位，维护公司的良好声誉。" show-word-limit type="textarea" rows="16" resize="none" />
      </el-form-item>
    </el-form>

  </div>
  <TrackSettingDialog ref="trackSettingDialogRef" @handleClose="handleTrackSettingDialogClose" />
</template>

<script setup>
import { defineProps, defineEmits, toRefs, computed, ref, defineExpose, onMounted } from "vue";
import { fetchPromptGenerate, fetchGetAppUserInfo } from '@/request/aiAction';

import TrackSettingDialog from "@/components/SuperAIHelper/TrackSettingDialog.vue"

const props = defineProps({
  agentBasicInfo: {
    type: Object,
    required: true,
    default: () => ({
      projectName: '',
      description: '',
      prePrompt: ''
    })
  },
});

const emit = defineEmits(['update:agentBasicInfo',]);

const { agentBasicInfo } = toRefs(props);

const agentBasicInfoVModel = computed({
  get() {
    return agentBasicInfo.value;
  },
  set(value) {
    emit('update:agentBasicInfo', value);
  }
});

const rules = {
  projectName: [
    { required: true, message: '请输入智能体名称', trigger: 'blur' }
  ],
  description: [
    { required: false, message: '请描述您的智能体', trigger: 'blur' }
  ],
  prePrompt: [
    { required: false, message: '请输入角色指令', trigger: 'blur' }
  ]
};

const form = ref(null);
const validateForm = () => {
  return new Promise((resolve) => {
    form.value.validate((valid) => {
      if (valid) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  });
};


const trackSettingDialogRef = ref(null); // 赛道设置弹窗
let popoverDisabled = ref(false); // 赛道设置按钮是否禁用

// 处理关闭赛道设置弹窗
async function handleTrackSettingDialogClose() {
  await getUserInfo();
  getCheckTrackSelectList();
  popoverDisabled.value = false;
}
// 打开赛道设置弹窗
function openTrackSettingDialog() {
  popoverDisabled.value = true;
  trackSettingDialogRef.value.openDialog();
}

let btnLoading = ref(false);
const myTrackList = ref([]); // 我的赛道列表
const currentTrack = ref([]); // 当前赛道
const currentRole = ref(""); // 当前职业


// 处理ai帮我写
async function handleAiWrite() {
  // 首先获取请求所需要的所有信息
  // 从本地存储中获取行业与职业
  btnLoading.value = true;
  const selectedTracks = myTrackList.value
    .filter((track) => track.selected)
    .map((track) => track.label)
    .join(",");
  // console.log(localCurrentRole);
  // console.log(localCheckTrackSelectList);

  const inputs = {
    content: agentBasicInfoVModel.value.prePrompt,
    creator: currentRole.value || "自媒体工作者",
    industry: selectedTracks || "作者",
    numbers: "500",
  };
  // 封装请求体
  const requestBody = {
    inputs,
    response_mode: "streaming",
    user: "abc-123",
  };

  try {
    const response = await fetchPromptGenerate(requestBody);
    if (!response.body) return;
    const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
    let result = "";
    let firstResultReceived = false;
    let buffer = "";

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += value;

      // 处理每一块数据
      const lines = buffer.split("\n");
      buffer = lines.pop() || ""; // 保留最后一个不完整的行

      for (const line of lines) {
        const cleanedValue = line.replace(/^data: /, "").trim();
        if (cleanedValue) {
          try {
            const json = JSON.parse(cleanedValue);
            if (json.data && json.data.text) {
              if (!firstResultReceived) {
                agentBasicInfoVModel.value.prePrompt = ""; // 清空提示词
                firstResultReceived = true;
              }
              agentBasicInfoVModel.value.prePrompt += json.data.text;
            }
          } catch (e) {
            console.error("Error parsing JSON:", e);
          }
        }
      }
    }
    // 处理完整的结果
    // console.log("完整的结果:", result);
  } catch (error) {
    console.error("Error fetching prompt generate:", error);
  } finally {
    btnLoading.value = false;
  }
}
// 获取用户信息
async function getUserInfo() {
  const res = await fetchGetAppUserInfo();
  if (res) {
    let { data, code } = res.data
    if (code !== 200) return
    // localStorage.setItem('userInfo', JSON.stringify(data));
    const { trade = "", profession = "" } = res.data.data
    currentTrack.value = trade ? trade.split(",") : [];
    currentRole.value = profession ? profession : "";
  }
}
// 异步获取选中的赛道 模拟
async function getCheckTrackSelectList() {
  // 将选中的赛道添加到myTrackList
  myTrackList.value = currentTrack.value.map((item) => {
    return {
      id: 0,
      selected: true,
      label: item,
    };
  });
}
onMounted(async () => {
  await getUserInfo()
  getCheckTrackSelectList();
});


defineExpose({
  validateForm
})
</script>

<style scoped lang="scss">
.basic-information {
  width: 100%;
  height: 100%;
  color: #fff;
  padding: 20px;
  background-color: #1e1e1e;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;

  .header {
    margin-bottom: 20px;
  }

  .title {
    font-size: 13px;
    display: flex;
    align-items: center;
    color: #ecf0f1;

    .icon {
      margin-right: 10px;
      font-size: 20px;
    }
  }

  .form-container {
    height: calc(100% - 40px);
    background-color: rgba(89, 63, 165, 0.075);
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    :deep() {

      .el-form-item__label {
        width: 100%;
      }
    }

    .form-label {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .form-label-right {
        display: flex;
        align-items: center;
        gap: 10px; // 增加间距
        font-size: 14px; // 调整字体大小
        color: #ecf0f1; // 设置字体颜色


        .ai-helper-button {
          padding: 3px 8px;
          border: none;
          color: #fff;
          font-size: 13px;
          border: 1px solid #ff6bcb3b;

          .bard-star {
            font-size: 20px;
            background: linear-gradient(135deg, #ff6bcc 0%, #228cff 78%);
            background-size: 200% 200%;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

          }



          &:hover {
            background-image: linear-gradient(180deg, #7f54f9 0%, #5754f9 100%);
            color: #fff;
          }
        }
      }
    }
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .el-input {
    width: 100%;
  }

  .form-input {
    :deep() {
      .el-textarea__inner {
        box-shadow: none;
      }
    }
  }
}
</style>